// @flow
import * as React from 'react';
import {useHistory, useParams} from 'react-router-dom';
import styled from 'styled-components';
import LocalizedImage from 'components/LocalizedImage';

import {LayoutRightMiddle} from 'components/Layout';
import {LocalizedParagraph, useLocalized} from 'components/Localized';
import Logo from 'components/Logo'
import ModalExteriorColor from 'components/ModalExteriorColor';
import {useExteriorColorCode} from 'components/Session';
import {loadSceneColorSelect, loadSceneColorSelect2} from 'utils/vrUtils';
import Loading from '../Loading';
import Disclaimer from 'components/Disclaimer'
import * as AudioUtils from 'utils/audioUtils';
import SoundToggleButton from 'components/SoundToggleButton';
import ButtonNextPage from 'components/ButtonNextPage';

type Props = {
  nextPath: string,
};

export default function ExteriorColor(props: Props): React.Element<any> {
  const history = useHistory();
  const { cv } = useParams();
  const localized = useLocalized();
  const [openModalExteriorColor, setOpenModalExteriorColor] = React.useState(true);
  const colorCode = useExteriorColorCode();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleNext = React.useCallback(() => {
    window.tagManager.colorSelctionLetsDriveLinkClick();
    history.push(props.nextPath.replace(":cv", cv));
  }, [cv, history, props.nextPath]);
  React.useEffect(()=>{
    AudioUtils.playBGM_UI();
    return ()=>{
    };
  }, []);
  
//setIsLoading(false);
  React.useEffect(() => {
    setIsLoading(true);
    if (cv === "cv-gt-line") {
      loadSceneColorSelect2(colorCode, ()=>{
        setIsLoading(false);
      });
    } else {
      //cv == cv-e-gt
      loadSceneColorSelect(colorCode, ()=>{
        setIsLoading(false);
      });
    }

  }, [cv, colorCode])

  React.useEffect(()=>{
    window.tagManager.colorSelectionPage();
  },[]);

  return (
    <Wrapper>

      {openModalExteriorColor && <WrapperTop>
        {cv === 'cv-e-gt' ? <LocalizedParagraph {...localized.tutorial_p04_color_001} /> : <LocalizedParagraph {...localized.tutorial_p04_color_003} /> }
      </WrapperTop>}
      <SoundToggleButton />
      <WrapperBottom>
        <VRArea></VRArea>
        <WrapperRight></WrapperRight>
      </WrapperBottom>
      <LayoutRightMiddle>
        <ColorButton onClick={() => {
          setOpenModalExteriorColor(true);
          window.tagManager.colorSelctionReSelectionLinkClick();
        }}>
          <LocalizedImage source="./driving-zone/btn-color.png" />
        </ColorButton>
      </LayoutRightMiddle>
      <ButtonNextPage title={localized.tutorial_p04_color_002} onNext={handleNext} widthM={110} widthD={193} />
      <ModalExteriorColor
        open={openModalExteriorColor}
        onClose={() => setOpenModalExteriorColor(false)}
      />
      <Logo />
      <Disclaimer textKey="disclaimer_default" onPopupOpen={()=>{
        setOpenModalExteriorColor(false);
      }} />
      {isLoading && (<Loading></Loading>) }
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  pointer-events: none;

`;
const WrapperTop = styled.div`
  width: calc(100% - ${(props) => (props.theme.layout.mobile ? 200 * (props.theme.layout.scale ?? 1) : 417)}px);
  height: ${(props) => (props.theme.layout.mobile ? 67 * (props.theme.layout.scale ?? 1) : 147)}px;
  padding-top: ${(props) => (props.theme.layout.mobile ? 30 : 56)}px;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  p {
    text-align: center;
  }
`;
const WrapperBottom = styled.div`
  flex: 1;
  display: flex;
`;
const WrapperRight = styled.div`
  display: flex;
  align-items: center;
  width: ${(props) => (props.theme.layout.mobile ? 200 * (props.theme.layout.scale ?? 1) : 417)}px;
  padding-bottom: ${(props) => (props.theme.layout.mobile ? 61 : 130)}px;
  button {
    pointer-events: auto;
  }
  div {
    transform-origin: left center;
  }
`;
const VRArea = styled.div`
  flex: 1;
  margin-left: ${(props) => (props.theme.layout.mobile ? 41 : 233)}px;
  margin-right: ${(props) =>
    props.theme.layout.mobile ? (props.completed ? 22 : 41) : props.completed ? -20 : 233}px;
  margin-bottom: ${(props) => (props.theme.layout.mobile ? 19 : 52)}px;
  /* background-image: url(${(props) => props.image});
  background-image: -webkit-image-set(
    url(${(props) => props.image}) 1x,
    url(${(props) => props.image2x}) 2x,
    url(${(props) => props.image3x}) 3x
  ); */
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  transform-origin: left bottom;
  visibility: hidden;
`;
const ColorButton = styled.button`
  width: ${(props) => (props.theme.layout.mobile ? 90 : 140)}px;
  height: ${(props) => (props.theme.layout.mobile ? 90 : 140)}px;
  margin-right: ${(props) => (props.theme.layout.mobile ? 30 : 135)}px;
  img {
    width: 100%;
    height: 100%;
  }
`;
